(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["editorial-banner"] && !Shopify.designMode) return;
  try {
    
  class EditorialBanner {
    constructor(element) {
      this.element = element;
      this.slides = Array.from(element.querySelectorAll('[data-editorial-slide]'));
      this.paginationItems = Array.from(element.querySelectorAll('[data-editorial-pagination]'));
      this.progressBars = this.paginationItems.map((item) => item.querySelector('.editorial-banner__pagination-progress'));
      this.prevButton = element.querySelector('[data-editorial-prev]');
      this.nextButton = element.querySelector('[data-editorial-next]');
      this.currentIndex = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
      this.currentIndex = this.currentIndex >= 0 ? this.currentIndex : 0;
      this.previousIndex = -1;
      this.autoplayDelay = Number(element.dataset.autoplaySpeed) || 7000;
      this.transitionDuration = 720;
      this.transitionTimeout = null;
      this.raf = null;
      this.progress = 0;
      this.lastTime = null;
      this.lastProgressPaint = 0;
      this.touchStartX = 0;
      this.touchStartY = 0;
      this.touchDeltaX = 0;
      this.touchDeltaY = 0;
      this.touchActive = false;
      this.manualPauseUntil = 0;
      this.loadedSlides = new Set();
      this.boundImageLoad = (event) => this.handleImageLoad(event);
      this.boundTick = (time) => this.tick(time);
      this.boundPause = () => this.pause();
      this.boundResume = () => this.resume();
      this.isDesktopViewport = window.matchMedia('(min-width: 750px)').matches;
      this.boundResize = () => this.handleResize();
      this.boundVisibility = () => {
        if (document.hidden) {
          this.pause();
        } else {
          this.resume();
        }
      };

      if (this.slides.length <= 1) return;

      this.bindEvents();
      this.bindImageState();
      this.loadSlideMedia(this.currentIndex);
      this.updateUI();
      this.resume();
    }

    bindEvents() {
      this.prevButton?.addEventListener('click', () => this.goTo(this.currentIndex - 1, { fromUser: true }));
      this.nextButton?.addEventListener('click', () => this.goTo(this.currentIndex + 1, { fromUser: true }));
      this.paginationItems.forEach((item) => {
        item.addEventListener('click', () => this.goTo(Number(item.dataset.slideIndex), { fromUser: true }));
      });

      this.element.addEventListener('mouseenter', (event) => {
        if (this.isHeaderInteraction(event)) return;
        this.boundPause();
      });
      this.element.addEventListener('mouseleave', (event) => {
        if (this.isHeaderInteraction(event)) return;
        this.boundResume();
      });
      this.element.addEventListener('focusin', (event) => {
        if (this.isHeaderInteraction(event)) return;
        this.boundPause();
      });
      this.element.addEventListener('focusout', (event) => {
        if (this.isHeaderInteraction(event)) return;
        this.boundResume();
      });
      this.element.addEventListener('touchstart', (event) => this.handleTouchStart(event), { passive: true });
      this.element.addEventListener('touchmove', (event) => this.handleTouchMove(event), { passive: true });
      this.element.addEventListener('touchend', () => this.handleTouchEnd(), { passive: true });
      this.element.addEventListener('touchcancel', () => this.handleTouchCancel(), { passive: true });
      document.addEventListener('visibilitychange', this.boundVisibility);
      window.addEventListener('resize', this.boundResize, { passive: true });
      window.visualViewport?.addEventListener('resize', this.boundResize, { passive: true });
    }

    isHeaderInteraction(event) {
      const target = event.target;
      if (!(target instanceof Element)) return false;
      return Boolean(target.closest('.editorial-banner__header-layer'));
    }

    bindImageState() {
      this.slides.forEach((slide) => {
        const image = slide.querySelector('.editorial-banner__image');
        if (!image) return;

        if (image.complete && image.currentSrc) {
          slide.classList.add('is-media-loaded');
          return;
        }

        image.addEventListener('load', this.boundImageLoad, { once: true });
      });
    }

    handleImageLoad(event) {
      const image = event.target;
      if (!(image instanceof HTMLImageElement)) return;

      const slide = image.closest('[data-editorial-slide]');
      if (slide) {
        slide.classList.add('is-media-loaded');
      }
    }

    goTo(index, options = {}) {
      const total = this.slides.length;
      if (!total) return;

      const nextIndex = (index + total) % total;
      if (nextIndex === this.currentIndex) return;

      const prevIndex = this.currentIndex;
      window.clearTimeout(this.transitionTimeout);
      this.element.classList.add('editorial-banner--animating');
      this.previousIndex = prevIndex;
      this.currentIndex = nextIndex;
      this.progress = 0;
      this.lastTime = null;
      this.updateUI();
      this.transitionTimeout = window.setTimeout(() => {
        this.previousIndex = -1;
        this.element.classList.remove('editorial-banner--animating');
        this.updateUI();
      }, this.transitionDuration);

      if (options.fromUser) {
        this.pauseAfterUserInteraction();
        return;
      }

      this.restart();
    }

    pauseAfterUserInteraction() {
      window.clearTimeout(this.manualPauseTimeout);
      this.pause();
      this.manualPauseUntil = performance.now() + this.autoplayDelay;

      this.manualPauseTimeout = window.setTimeout(() => {
        this.manualPauseUntil = 0;
        this.resume();
      }, this.autoplayDelay);
    }

    updateUI() {
      this.loadSlideMedia(this.currentIndex);

      this.slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === this.currentIndex);
        slide.classList.toggle('is-previous', slideIndex === this.previousIndex);
      });

      this.paginationItems.forEach((item, itemIndex) => {
        item.classList.toggle('is-active', itemIndex === this.currentIndex);
      });

      this.updateProgressBar(true);
    }

    loadSlideMedia(index) {
      const total = this.slides.length;
      if (!total) return;

      const normalizedIndex = (index + total) % total;
      if (this.loadedSlides.has(normalizedIndex)) return;

      const slide = this.slides[normalizedIndex];
      if (!slide) return;

      const picture = slide.querySelector('picture');
      if (!picture) {
        this.loadedSlides.add(normalizedIndex);
        return;
      }

      if (window.matchMedia('(min-width: 750px)').matches) {
        picture.querySelectorAll('source[data-srcset]').forEach((source) => {
          source.setAttribute('srcset', source.dataset.srcset);
          source.removeAttribute('data-srcset');
        });
      } else {
        picture.querySelectorAll('source[data-srcset]').forEach((source) => {
          source.setAttribute('srcset', source.dataset.srcset);
          source.removeAttribute('data-srcset');
        });
      }

      const image = picture.querySelector('img[data-src]');
      if (image) {
        if (image.dataset.srcset) {
          image.setAttribute('srcset', image.dataset.srcset);
          image.removeAttribute('data-srcset');
        }
        image.src = image.dataset.src;
        image.removeAttribute('data-src');
      }

      this.loadedSlides.add(normalizedIndex);
    }

    updateProgressBar(force = false, time = performance.now()) {
      if (!force && time - this.lastProgressPaint < 100) return;
      this.lastProgressPaint = time;

      this.progressBars.forEach((bar, index) => {
        if (!bar) return;

        if (index < this.currentIndex) {
          bar.style.transform = 'scaleX(0)';
          return;
        }

        if (index > this.currentIndex) {
          bar.style.transform = 'scaleX(0)';
          return;
        }

        const progressScale = Math.min(this.progress / this.autoplayDelay, 1);
        bar.style.transform = `scaleX(${progressScale})`;
      });
    }

    restart() {
      window.clearTimeout(this.manualPauseTimeout);
      this.manualPauseUntil = 0;
      this.pause();
      this.resume();
    }

    pause() {
      if (this.raf) {
        window.cancelAnimationFrame(this.raf);
        this.raf = null;
      }
      this.lastTime = null;
    }

    resume() {
      if (document.hidden || this.slides.length <= 1 || this.raf) return;
      if (performance.now() < this.manualPauseUntil) return;
      this.raf = window.requestAnimationFrame(this.boundTick);
    }

    tick(time) {
      if (this.lastTime === null) {
        this.lastTime = time;
      }

      this.progress += time - this.lastTime;
      this.lastTime = time;
      this.updateProgressBar(false, time);

      if (this.progress >= this.autoplayDelay) {
        this.pause();
        this.goTo(this.currentIndex + 1);
        return;
      }

      this.raf = window.requestAnimationFrame(this.boundTick);
    }

    handleTouchStart(event) {
      if (this.slides.length <= 1 || event.touches.length !== 1) return;
      if (this.isHeaderInteraction(event)) return;

      const touch = event.touches[0];
      this.touchStartX = touch.clientX;
      this.touchStartY = touch.clientY;
      this.touchDeltaX = 0;
      this.touchDeltaY = 0;
      this.touchActive = true;
      this.pause();
    }

    handleTouchMove(event) {
      if (!this.touchActive || event.touches.length !== 1) return;

      const touch = event.touches[0];
      this.touchDeltaX = touch.clientX - this.touchStartX;
      this.touchDeltaY = touch.clientY - this.touchStartY;
    }

    handleTouchEnd() {
      if (!this.touchActive) return;

      const absX = Math.abs(this.touchDeltaX);
      const absY = Math.abs(this.touchDeltaY);

      if (absX > 40 && absX > absY) {
        if (this.touchDeltaX < 0) {
          this.goTo(this.currentIndex + 1, { fromUser: true });
        } else {
          this.goTo(this.currentIndex - 1, { fromUser: true });
        }
      } else {
        this.resume();
      }

      this.touchActive = false;
      this.touchDeltaX = 0;
      this.touchDeltaY = 0;
    }

    handleTouchCancel() {
      this.touchActive = false;
      this.touchDeltaX = 0;
      this.touchDeltaY = 0;
      this.resume();
    }

    handleResize() {
      const isDesktopViewport = window.matchMedia('(min-width: 750px)').matches;
      if (isDesktopViewport === this.isDesktopViewport) return;

      this.isDesktopViewport = isDesktopViewport;
      this.loadedSlides.clear();
      this.loadSlideMedia(this.currentIndex);

      if (this.slides.length > 1) {
        this.loadSlideMedia(this.currentIndex + 1);
      }
    }
  }

  const initializeEditorialBanners = (root = document) => {
    root.querySelectorAll('[data-editorial-banner]').forEach((element) => {
      if (!element.__editorialBanner) {
        element.__editorialBanner = new EditorialBanner(element);
      }
    });
  };

  if (!window.__editorialBannerInitialized) {
    window.__editorialBannerInitialized = true;
    document.addEventListener('DOMContentLoaded', () => initializeEditorialBanners());
    document.addEventListener('shopify:section:load', (event) => initializeEditorialBanners(event.target));
  }

  } catch(e) { console.error(e); }
})();
})();
